export enum KEYCODE {
  UP = 38,
  DOWN = 40,
  LEFT = 37,
  RIGHT = 39,
  ESCAPE = 27,
  ENTER = 13,
  TAB = 9,
}
